import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorageEngine from "redux-persist/lib/storage/session";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import App from "./app/reducer";
import Auth from "./auth/reducer";
import EditableTable from "@redux/EditableTable/reducer";
import Company from "@redux/company/reducer";
import Facility from "@redux/facility/reducer";
import Electricity from "@redux/electricity/reducer";
import Water from "@redux/water/reducer";
import Gas from "@redux/gas/reducer";
import WorkOrder from "@redux/workorder/reducer";
import Picklist from "@redux/picklist/reducer";
import SavingFilters from "@redux/SavingFilters/reducer";
import PDF from "@redux/pdf/reducer";
import Project from "@redux/project/reducer";
import Task from "@redux/task/reducer";
import SubTask from "@redux/subtask/reducer";
import Equipment from "@redux/equipment/reducer";
import EquipmentCategory from "@redux/equipmentCategory/reducer";
import FacilityCategory from "@redux/facilityCategory/reducer";
import ProjectComment from "@redux/projectcomment/reducer";
import WorkdorderComment from "@redux/workordercomment/reducer";
import EquipmentComment from "@redux/equipmentcomment/reducer";
import StationTemperature from "@redux/StationTemperature/reducer";
import FacilityBenchmark from "@redux/facilitybenchmark/reducer";
import Scenario from "@redux/Scenario/reducer";
import Notification from "@redux/notification/reducer";
import GlobalData from "@redux/global/reducer";
import GlobalSearch from "@redux/global-search/reducer";
import authActions from "@redux/auth/actions";

const authPersistConfig = {
  key: "auth",
  storage,
  stateReconciler: hardSet,
  whitelist: [
    "access",
    "refresh",
    "accessTokenExpiration",
    "refreshTokenExpiration",
    "userId",
    "user",
    "role",
    "permission",
    "company",
    "user_facilities",
    "is_companyadmin",
    "is_superuser",
    "first_name",
    "last_name",
    "middle_name",
    "email",
    "image",
    "sessionEpoch",
  ],
};

/**
 * Persist only the fields needed for Switch View pre-fill.
 * Uses sessionStorage so data clears when the browser tab is closed,
 * and is purged alongside Auth on logout via persistor.purge().
 */
const appViewPersistConfig = {
  key: "view-ctx",
  storage: sessionStorageEngine,
  whitelist: ["viewMode"],
};

const companyCtxPersistConfig = {
  key: "company-ctx",
  storage: sessionStorageEngine,
  whitelist: ["selectedId"],
};

const facilityCtxPersistConfig = {
  key: "facility-ctx",
  storage: sessionStorageEngine,
  whitelist: ["selected"],
};

const appReducer = combineReducers({
  App: persistReducer(appViewPersistConfig, App),
  Auth: persistReducer(authPersistConfig, Auth),
  EditableTable,
  WorkOrder,
  Equipment,
  EquipmentCategory,
  FacilityCategory,
  Company: persistReducer(companyCtxPersistConfig, Company),
  Facility: persistReducer(facilityCtxPersistConfig, Facility),
  Electricity,
  Water,
  Gas,
  SavingFilters,
  Picklist,
  PDF,
  Project,
  Task,
  SubTask,
  ProjectComment,
  WorkdorderComment,
  EquipmentComment,
  FacilityBenchmark,
  StationTemperature,
  Scenario,
  Notification,
  GlobalData,
  GlobalSearch,
});

const rootReducer = (state, action) => {
  if (
    action.type === authActions.SESSION_RESET ||
    action.type === authActions.SESSION_RESET_REMOTE
  ) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
